/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedResourcesDistributionRule } from '../../models/paged-resources-distribution-rule';

export interface GetRules$Params {
  'Active-Tenant-Identifier': string;
  page?: number;
  size?: number;
  filter?: Array<string>;
  archived?: boolean;
}

export function getRules(http: HttpClient, rootUrl: string, params: GetRules$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedResourcesDistributionRule>> {
  const rb = new RequestBuilder(rootUrl, getRules.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('filter', params.filter, {"style":"form","explode":true});
    rb.query('archived', params.archived, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedResourcesDistributionRule>;
    })
  );
}

getRules.PATH = '/distribution-rules';
